import en from './en.json';

export const messages = {
    en
};

export const DEFAULT_LOCALE = 'en';
